<title>Not Found</title>
<div class="error-page">
    <div class="error-image">
        <img class="img-fluid" src="assets/images/illustration/error404.svg" alt="Error page" />
    </div>
    <div class="error-message">
        <img class="oops-img" src="assets/images/illustration/Oops.svg" alt="Error page" />
        <p>Page non trouvée...</p>
    </div>
</div>